// test2742
(2742 && 0);
